<template>
    <div class="col-md-12">
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>
        <div class="h2 mb-3">Reporting</div>
        <div class="loader" v-if="loading"></div>
        <form @submit.prevent="exportBookings">
            <div class="container-fluid bg-light py-3">
                <div class="row">
                    <div class="col-md-12">
                        <div class="p-4 mb-3 bg-white rounded-lg">
                            <div class="h4 mb-3">Accounting</div>
                            <div class="bg-light p-3">
                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-5">
                                            <label><b>Start</b></label>
                                            <div class="form-group d-flex">
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2 mr-3 flex-1"
                                                    :class="date_single_from==='' && isSubmit? 'border-danger':''">
                                                    <date-picker v-model="date_single_from" required
                                                                 valueType="YYYY-MM-DD"
                                                                 input-class="border-0 py-0 shadow-none form-input"
                                                                 placeholder="dd/mm/yyyy"
                                                                 :lang="datePickerOptions.lang"
                                                                 format="DD/MM/YYYY"></date-picker>
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                                <!--                                                <div
                                                                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                                                                    :class="time_from==='' && isSubmit? 'border-danger':''">
                                                                                                    <vue-timepicker placeholder="" v-model="time_from"
                                                                                                                    input-class="border-0 py-0 shadow-none form-input"></vue-timepicker>
                                                                                                    <span
                                                                                                        class="material-icons-outlined  pr-2 text-primary">schedule</span>
                                                                                                </div>-->
                                            </div>
                                        </div>
                                        <div class="col-md-2 d-flex align-items-center justify-content-center">
                                            <span class="h1 m-0">~</span>
                                        </div>
                                        <div class="col-md-5">
                                            <label><b>End</b></label> <br>
                                            <div class="form-group  d-flex">
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2 mr-3 flex-1"
                                                    :class="date_single_to==='' && isSubmit? 'border-danger':''">
                                                    <date-picker v-model="date_single_to" valueType="YYYY-MM-DD"
                                                                 input-class="border-0 py-0 shadow-none form-input"
                                                                 placeholder="dd/mm/yyyy"
                                                                 :lang="datePickerOptions.lang"
                                                                 format="DD/MM/YYYY"></date-picker>

                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="form-group row">
                                        <div v-for="(item,index) in reportingColums" :key="index">
                                            <div class="col-md-12">
                                                <label class="newInput" :for="item.id">
                                                    {{ item.label }}
                                                    <input type="checkbox"
                                                           name="reportingIds"
                                                           :value="item.id"
                                                           :id="item.id"
                                                           v-model="item.checked"
                                                    >
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button type="submit" class="btn mt-3 btn-primary" @click="validation();">
                                Run export
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <form @submit.prevent="exportDriversV2">
            <div class="container-fluid bg-light py-3">
                <div class="row">
                    <div class="col-md-12">
                        <div class="p-4 mb-3 bg-white rounded-lg">
                            <div class="h4 mb-3">Warehousing</div>
                            <div class="bg-light p-3">
                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-6">
                                            <label><b>Date</b></label>
                                            <div class="form-group">
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2 mr-3 flex-1"
                                                    :class="trips.date==='' && isSubmitList? 'border-danger':''">
                                                    <date-picker
                                                        aria-required="true"
                                                        v-model="trips.date"
                                                        valueType="YYYY-MM-DD"
                                                        input-class="border-0 py-0 shadow-none form-input"
                                                        placeholder="dd/mm/yyyy"
                                                        format="DD/MM/YYYY"
                                                        :lang="datePickerOptions.lang"
                                                        v-on:input="getDrivers()"
                                                    >
                                                    </date-picker>
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label><b>Driver</b></label>
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                    :class="trips.driver==='' && isSubmitList? 'border-danger':''">
                                                    <select
                                                        required
                                                        class="form-control border-0 py-0 shadow-none pr-5"
                                                        v-model="trips.driver">
                                                        <option value="0" selected>All</option>
                                                        <option value="1" selected>Unassigned</option>
                                                        <option v-for="item in drivers" v-bind:value="item.id">
                                                            {{ item.name }}
                                                        </option>
                                                    </select>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-md-12">
                                            <label class="newInput" for="print-returnlabels">
                                                Print returnlabels
                                                <input type="checkbox"
                                                       id="print-returnlabels"
                                                       v-model="trips.printReturnLabels"
                                                >
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button type="submit" class="btn mt-3 btn-primary" @click="validationList()">
                                Generate picklist
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <form @submit.prevent="exportDriverFees">
            <div class="container-fluid bg-light py-3">
                <div class="row">
                    <div class="col-md-12">
                        <div class="p-4 mb-3 bg-white rounded-lg">
                            <div class="h4 mb-3">External driver fees</div>
                            <div class="bg-light p-3">
                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-5">
                                            <label><b>Start</b></label>
                                            <div class="form-group d-flex">
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2 mr-3 flex-1"
                                                    :class="driverFeesFilters.from === '' && isSubmit ? 'border-danger':''">
                                                    <date-picker v-model="driverFeesFilters.from" required
                                                                 valueType="YYYY-MM-DD"
                                                                 input-class="border-0 py-0 shadow-none form-input"
                                                                 placeholder="dd/mm/yyyy"
                                                                 :lang="datePickerOptions.lang"
                                                                 format="DD/MM/YYYY"></date-picker>
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-2 d-flex align-items-center justify-content-center">
                                            <span class="h1 m-0">~</span>
                                        </div>
                                        <div class="col-md-5">
                                            <label><b>End</b></label> <br>
                                            <div class="form-group  d-flex">
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2 mr-3 flex-1"
                                                    :class="driverFeesFilters.to === '' && isSubmit? 'border-danger':''">
                                                    <date-picker v-model="driverFeesFilters.to" valueType="YYYY-MM-DD"
                                                                 input-class="border-0 py-0 shadow-none form-input"
                                                                 placeholder="dd/mm/yyyy"
                                                                 :lang="datePickerOptions.lang"
                                                                 format="DD/MM/YYYY"></date-picker>

                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="form-group row">
                                        <div v-for="(item,index) in driverFeesFilters.reportingColums" :key="index">
                                            <div class="col-md-12">
                                                <label class="newInput" :for="`df-${item.id}`">
                                                    {{ item.label }}
                                                    <input type="checkbox"
                                                           name="reportingIds"
                                                           :value="item.id"
                                                           :id="`df-${item.id}`"
                                                           v-model="item.checked"
                                                    >
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button type="submit" class="btn mt-3 btn-primary" @click="validation();">
                                Run export
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <form @submit.prevent="exportDriverCosts">
            <div class="container-fluid bg-light py-3">
                <div class="row">
                    <div class="col-md-12">
                        <div class="p-4 mb-3 bg-white rounded-lg">
                            <div class="h4 mb-3">Drivers cost report</div>
                            <div class="bg-light p-3">
                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-4">
                                            <label><b>From</b></label>
                                            <div class="form-group d-flex">
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2 mr-3 flex-1"
                                                    :class="driversCostFilter.from === '' && isSubmit ? 'border-danger':''">
                                                    <date-picker v-model="driversCostFilter.from" required
                                                                 valueType="YYYY-MM-DD"
                                                                 input-class="border-0 py-0 shadow-none form-input"
                                                                 placeholder="dd/mm/yyyy"
                                                                 :lang="datePickerOptions.lang"
                                                                 @change="clearDriversCostErrors('from'); getCompanyNames();"
                                                                 format="DD/MM/YYYY"></date-picker>
                                                    <div class="text-danger" v-if="driversCostErrors['from']">
                                                        {{ driversCostErrors['from'] }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <label><b>To</b></label>
                                            <div class="form-group d-flex">
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2 mr-3 flex-1"
                                                    :class="driversCostFilter.to === '' && isSubmit ? 'border-danger':''">
                                                    <date-picker v-model="driversCostFilter.to" required
                                                                 valueType="YYYY-MM-DD"
                                                                 input-class="border-0 py-0 shadow-none form-input"
                                                                 placeholder="dd/mm/yyyy"
                                                                 :lang="datePickerOptions.lang"
                                                                 @change="clearDriversCostErrors('to'); getCompanyNames();"
                                                                 format="DD/MM/YYYY"></date-picker>
                                                    <div class="text-danger" v-if="driversCostErrors['to']">
                                                        {{ driversCostErrors['to'] }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <label><b>Company</b></label>
                                            <div class="form-group">
                                                <div class="align-items-center bg-white border rounded-lg div-focus border-2 dropdown-near-to-bottom">
                                                    <v-select
                                                        :options="companyNames"
                                                        v-model="driversCostFilter.company"
                                                        label="name"
                                                        id="driver"
                                                        class="custom-v-select"
                                                        @input="clearDriversCostErrors('company')"
                                                    >
                                                        <template #option="{ name }">
                                                            <div>
                                                                <span>{{ name }}</span>
                                                            </div>
                                                        </template>
                                                        <template #selected-option="{ name }">
                                                            <span>{{ name }}</span>
                                                        </template>
                                                    </v-select>
                                                </div>
                                                <div class="text-danger" v-if="driversCostErrors['company']">
                                                    {{ driversCostErrors['company'] }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button type="submit" class="btn mt-3 btn-primary" @click="validation();">
                                Run export
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <driver-mapping-pop-up></driver-mapping-pop-up>

    </div>
</template>

<script>

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import datePickerOptionsMixin from "../mixins/datePickerOptionsMixin";
import printLabelsMixin from "../mixins/printLabelsMixin";
import DriverMappingPopUp from "./reusable/DriverMappingPopUp.vue";

export default {
    name: "Settings",
    mixins: [datePickerOptionsMixin, printLabelsMixin],
    components: {DatePicker, VueTimepicker, DriverMappingPopUp},
    props: {
        exportDriverCostUrl: {type: String, required: true},
        getCompanyNamesUrl: {type: String, required: true}
    },
    data() {
        return {
            reportingColums: [
                {
                    id: 'id',
                    label: 'Booking Id',
                    checked: true,
                },
                {
                    id: 'client',
                    label: 'Client',
                    checked: localStorage.getItem("reportingColumnsLocal") !== null &&
                        localStorage.getItem('reportingColumnsLocal').split(',').includes('client'),
                },
                {
                    id: 'agreement',
                    label: 'Agreement name',
                    checked: localStorage.getItem("reportingColumnsLocal") !== null &&
                        localStorage.getItem('reportingColumnsLocal').split(',').includes('agreement'),
                },
                {
                    id: 'pickup_address',
                    label: 'Pickup address',
                    checked: localStorage.getItem("reportingColumnsLocal") !== null &&
                        localStorage.getItem('reportingColumnsLocal').split(',').includes('pickup_address'),
                },
                {
                    id: 'pickup_date',
                    label: 'Pickup date',
                    checked: localStorage.getItem("reportingColumnsLocal") !== null &&
                        localStorage.getItem('reportingColumnsLocal').split(',').includes('pickup_date'),
                },
                {
                    id: 'dropoff_address',
                    label: 'Dropoff address',
                    checked: localStorage.getItem("reportingColumnsLocal") !== null &&
                        localStorage.getItem('reportingColumnsLocal').split(',').includes('dropoff_address'),
                },
                {
                    id: 'dropoff_date',
                    label: 'Dropoff date',
                    checked: localStorage.getItem("reportingColumnsLocal") !== null &&
                        localStorage.getItem('reportingColumnsLocal').split(',').includes('dropoff_date'),
                },
                {
                    id: 'product',
                    label: 'Product',
                    checked: localStorage.getItem("reportingColumnsLocal") !== null &&
                        localStorage.getItem('reportingColumnsLocal').split(',').includes('product'),
                },
                {
                    id: 'services',
                    label: 'Service',
                    checked: localStorage.getItem("reportingColumnsLocal") !== null &&
                        localStorage.getItem('reportingColumnsLocal').split(',').includes('services'),
                },
                {
                    id: 'total_weight',
                    label: 'Total weight',
                    checked: localStorage.getItem("reportingColumnsLocal") !== null &&
                        localStorage.getItem('reportingColumnsLocal').split(',').includes('total_weight'),
                },
                {
                    id: 'total_volume',
                    label: 'Total volume',
                    checked: localStorage.getItem("reportingColumnsLocal") !== null &&
                        localStorage.getItem('reportingColumnsLocal').split(',').includes('total_volume'),
                },
                {
                    id: 'total_colli',
                    label: 'Total colli',
                    checked: localStorage.getItem("reportingColumnsLocal") !== null &&
                        localStorage.getItem('reportingColumnsLocal').split(',').includes('total_colli'),
                },
                {
                    id: 'total_price',
                    label: 'Total price',
                    checked: localStorage.getItem("reportingColumnsLocal") !== null &&
                        localStorage.getItem('reportingColumnsLocal').split(',').includes('total_price'),
                },
                {
                    id: 'note',
                    label: 'Note',
                    checked: localStorage.getItem("reportingColumnsLocal") !== null &&
                        localStorage.getItem('reportingColumnsLocal').split(',').includes('note'),
                },
                {
                    id: 'reference',
                    label: 'Reference',
                    checked: localStorage.getItem("reportingColumnsLocal") !== null &&
                        localStorage.getItem('reportingColumnsLocal').split(',').includes('reference'),
                },
                {
                    id: 'driver',
                    label: 'Driver',
                    checked: localStorage.getItem("reportingColumnsLocal") !== null &&
                        localStorage.getItem('reportingColumnsLocal').split(',').includes('driver'),
                },
                {
                    id: 'internal_comment',
                    label: 'Internal comment',
                    checked: localStorage.getItem("reportingColumnsLocal") !== null &&
                        localStorage.getItem('reportingColumnsLocal').split(',').includes('internal_comment'),
                },
                {
                    id: 'status',
                    label: 'Booking status',
                    checked: localStorage.getItem("reportingColumnsLocal") !== null &&
                        localStorage.getItem('reportingColumnsLocal').split(',').includes('status'),
                },
                {
                    id: 'cost_price',
                    label: 'Cost price',
                    checked: localStorage.getItem("reportingColumnsLocal") !== null &&
                        localStorage.getItem('reportingColumnsLocal').split(',').includes('cost_price'),
                },
                {
                    id: 'external_driver',
                    label: 'External Driver',
                    checked: localStorage.getItem("reportingColumnsLocal") !== null &&
                        localStorage.getItem('reportingColumnsLocal').split(',').includes('external_driver'),
                },
                {
                    id: 'is_recurring',
                    label: 'Recurring booking name',
                    checked: localStorage.getItem("reportingColumnsLocal") !== null &&
                        localStorage.getItem('reportingColumnsLocal').split(',').includes('is_recurring'),
                },
            ],
            reportIds: [],
            date_from: 0,
            date_to: 0,
            date_single_from: '',
            date_single_to: '',
            trips: {
                printReturnLabels: false
            },
            loading: false,
            isSubmit: false,
            isSubmitList: false,
            drivers: {},
            bookings: {},
            role: 'admin',
            driverFeesFilters: {
                from: '',
                to: '',
                reportingColums: [
                    {
                        id: 'date',
                        label: 'Date',
                        checked: localStorage.getItem("reportingColumnsDriverFees") !== null &&
                            localStorage.getItem('reportingColumnsDriverFees').split(',').includes('date'),
                    },
                    {
                        id: 'driver',
                        label: 'Driver',
                        checked: localStorage.getItem("reportingColumnsDriverFees") !== null &&
                            localStorage.getItem('reportingColumnsDriverFees').split(',').includes('driver'),
                    },
                    {
                        id: 'cost',
                        label: 'Cost',
                        checked: localStorage.getItem("reportingColumnsDriverFees") !== null &&
                            localStorage.getItem('reportingColumnsDriverFees').split(',').includes('cost'),
                    },
                    {
                        id: 'fees',
                        label: 'Fees',
                        checked: localStorage.getItem("reportingColumnsDriverFees") !== null &&
                            localStorage.getItem('reportingColumnsDriverFees').split(',').includes('fees'),
                    },
                    {
                        id: 'net_cost',
                        label: 'Net cost',
                        checked: localStorage.getItem("reportingColumnsDriverFees") !== null &&
                            localStorage.getItem('reportingColumnsDriverFees').split(',').includes('net_cost'),
                    },
                    {
                        id: 'validated',
                        label: 'Validated',
                        checked: localStorage.getItem("reportingColumnsDriverFees") !== null &&
                            localStorage.getItem('reportingColumnsDriverFees').split(',').includes('validated'),
                    },
                ]
            },
            driversCostFilter: {
                from: '',
                to: '',
                company: ''
            },
            driversCostErrors: {
                from: '',
                to: '',
                company: ''
            },
            companyNames: [{name: 'All'}],
        }
    },
    methods: {
        fetchData() {
        },
        validation() {
            this.isSubmit = true;
        },
        validationList() {
            this.isSubmitList = true;
        },
        exportBookings() {
            if (this.date_single_from === '' || this.date_single_to === '') return false;
            this.date_from = this.date_single_from;
            this.date_to = this.date_single_to;
            localStorage.setItem('reportingColumnsLocal', this.reportingColums.filter(item => item.checked).map(name => name.id))

            this.loading = true;
            axios({
                url: `/settings/export-booking/${this.date_from}/${this.date_to}`,
                method: 'POST',
                responseType: 'arraybuffer',
                data: this.reportingColums.filter(item => item.checked).map(name => name.id)
            }).then((response) => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', `bookings_${Date.now()}.xlsx`);
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch((error) => {
                console.log(error);
                const response = JSON.parse(new TextDecoder().decode(error.response.data));
                this.flashMessage.error({
                    title: '',
                    message: response.message || 'Error',
                    time: 2000,
                    blockClass: 'flash-message error'
                });
                console.log(response.message);
            }).finally(() => {
                this.$Progress.finish();
                this.loading = false;
            });


        },
        exportDrivers() {
            this.loading = true;
            let date = new Date();
            this.trips.documentCreatedAt = date.getFullYear()
                + '' + (date.getMonth() + 1).toLocaleString('en-US', {minimumIntegerDigits: 2})
                + '' + date.getDate().toLocaleString('en-US', {minimumIntegerDigits: 2})
                + '' + date.getHours().toLocaleString('en-US', {minimumIntegerDigits: 2})
                + '' + date.getMinutes().toLocaleString('en-US', {minimumIntegerDigits: 2})
                + '' + date.getSeconds().toLocaleString('en-US', {minimumIntegerDigits: 2})
            ;
            axios({
                url: `/settings/export-drivers`,
                method: 'POST',
                responseType: 'blob',
                data: this.trips
            }).then((response) => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', `report_trips_${this.trips.documentCreatedAt}.pdf`);
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch((error) => {
                console.log(error);
                error.response.data.text().then(value => {
                    value = JSON.parse(value).message;
                    console.log(value);
                    this.flashMessage.error({
                        title: '',
                        message: value || 'Error',
                        time: 2000,
                        blockClass: 'flash-message error'
                    });
                });

            }).finally(() => {
                this.loading = false
            });
        },
        exportDriversV2() {
            this.loading = true;
            let date = new Date();
            this.trips.documentCreatedAt = date.getFullYear()
                + '' + (date.getMonth() + 1).toLocaleString('en-US', {minimumIntegerDigits: 2})
                + '' + date.getDate().toLocaleString('en-US', {minimumIntegerDigits: 2})
                + '' + date.getHours().toLocaleString('en-US', {minimumIntegerDigits: 2})
                + '' + date.getMinutes().toLocaleString('en-US', {minimumIntegerDigits: 2})
                + '' + date.getSeconds().toLocaleString('en-US', {minimumIntegerDigits: 2})
            ;
            localStorage.setItem('printReturnLabels', this.trips.printReturnLabels);
            axios({
                url: `/settings/export-drivers`,
                method: 'POST',
                data: this.trips
            }).then((response) => {
                if (response.data.files &&
                    response.data.files[0] &&
                    response.data.files[0]['url']
                ) {
                    response.data.files.forEach((fileData) => {
                        if (fileData['url'] && fileData['name']) {
                            var fileLink = document.createElement('a');
                            fileLink.href = fileData['url'];
                            fileLink.setAttribute('download', fileData['name']);
                            document.body.appendChild(fileLink);
                            fileLink.click();
                        }
                    });

                    if (this.trips.printReturnLabels &&
                        response.data.bookingIdsForLabels &&
                        response.data.bookingIdsForLabels.length
                    ) {
                        response.data.bookingIdsForLabels.forEach((item) => {
                            this.bookings[item] = true;
                        });
                        this.printLabels();
                    }
                } else {
                    this.flashMessage.error({
                        title: '',
                        message: 'No data',
                        time: 2000,
                        blockClass: 'flash-message error'
                    });
                }
            }).catch((error) => {
                console.log(error);
                error.response.data.text().then(value => {
                    value = JSON.parse(value).message;
                    console.log(value);
                    this.flashMessage.error({
                        title: '',
                        message: value || 'Error',
                        time: 2000,
                        blockClass: 'flash-message error'
                    });
                });

            }).finally(() => {
                this.loading = false
            });
        },
        getDrivers: function () {
            axios.get(`/trip-drivers/${this.trips.date}`)
                .then(({data}) => {
                    this.drivers = data.drivers;
                }).catch();
        },
        exportDriverFees() {
            if (this.driverFeesFilters.from === '' || this.driverFeesFilters.to === '') {
                return false;
            }

            this.date_from = this.driverFeesFilters.from;
            this.date_to = this.driverFeesFilters.to;
            localStorage.setItem(
                'reportingColumnsDriverFees',
                this.driverFeesFilters.reportingColums.filter(item => item.checked).map(name => name.id)
            );

            this.loading = true;
            axios({
                url: `/settings/export-driver-fees/${this.date_from}/${this.date_to}`,
                method: 'POST',
                responseType: 'arraybuffer',
                data: this.driverFeesFilters.reportingColums.filter(item => item.checked).map(name => name.id)
            }).then((response) => {
                console.log(response);
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', `driver_fees_${this.date_from}_${this.date_to}.xlsx`);
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch((error) => {
                console.log(error);
                const response = JSON.parse(new TextDecoder().decode(error.response.data));
                this.flashMessage.error({
                    title: '',
                    message: response.message || 'Error',
                    time: 2000,
                    blockClass: 'flash-message error'
                });
                console.log(response.message);
            }).finally(() => {
                this.$Progress.finish();
                this.loading = false;
            });


        },

        // ========================= //
        // == Drivers cost == //

        exportDriverCosts() {
            this.clearDriversCostErrors();
            let isValid = true;
            for (let key in this.driversCostFilter) {
                if (!this.driversCostFilter[key]) {
                    this.driversCostErrors[key] = 'The field is required';
                    isValid = false;
                }
            }

            if (isValid) {
                this.loading = true;
                axios.post(this.exportDriverCostUrl, this.driversCostFilter)
                    .then((response) => {
                        const fileData = response.data.file;
                        var fileLink = document.createElement('a');
                        fileLink.href = fileData['url'];
                        fileLink.setAttribute('download', fileData['name']);
                        document.body.appendChild(fileLink);
                        fileLink.click();

                        this.flashMessage.success({
                            title: '',
                            message: 'Success',
                            time: 2000,
                            blockClass: 'flash-message'
                        });

                        this.driversCostFilter = {
                            from: '',
                            to: '',
                            company: ''
                        }
                    }).catch((error) => {
                    this.flashMessage.error({
                        title: '',
                        message: error.response.data.message,
                        time: 2000,
                        blockClass: 'flash-message error'
                    });
                    console.log(error.response);
                    if (error.response.data && error.response.data.errors) {
                        for (let k in error.response.data.errors) {
                            if (k === 'filters.company.id' ||
                                k === 'filters.company.name'
                            ) {
                                this.driversCostErrors['company'] = error.response.data.errors[k][0];
                            } else if (k === 'filters.from') {
                                this.driversCostErrors['from'] = error.response.data.errors[k][0];
                            } else if (k === 'filters.to') {
                                this.driversCostErrors['to'] = error.response.data.errors[k][0];
                            }
                        }
                    }
                }).finally(() => {
                    this.loading = false;
                })
            }
        },
        clearDriversCostErrors(key = null) {
            if (key) {
                this.driversCostErrors[key] = '';
            } else {
                this.driversCostErrors = {
                    from: '',
                    to: '',
                    company: ''
                };
            }
        },
        getCompanyNames() {
            if (!this.driversCostFilter.from || !this.driversCostFilter.to) {
                return;
            }

            this.companyNames = [{name: 'All'}]

            axios.get(this.getCompanyNamesUrl, {params: {
                    fromDate: this.driversCostFilter.from,
                    toDate: this.driversCostFilter.to
                }}).then((response) => {
                if (response.data.companyNames) {
                    this.companyNames = this.companyNames.concat(response.data.companyNames);
                }

            }).catch((error) => {
                console.log(error.response);
                this.flashMessage.error({
                    title: '',
                    message: error.response.data.message,
                    time: 2000,
                    blockClass: 'flash-message error'
                });
            })

        }
    },
    created() {
        this.fetchData();
        let reportingColumnsLocal = localStorage.getItem("reportingColumnsLocal");
        let printReturnLabels = localStorage.getItem("printReturnLabels");

        if (reportingColumnsLocal !== null) {
            this.reportingColumnsLocal = reportingColumnsLocal.split(',');
        }
        if (printReturnLabels) {
            printReturnLabels = printReturnLabels === 'true';
            this.$set(this.trips, 'printReturnLabels', printReturnLabels);
        }

        if (localStorage.getItem("reportingColumnsDriverFees") !== null) {
            this.driverFeesFilters['reportingColumnsDriverFees'] = localStorage.getItem('reportingColumnsDriverFees').split(',');
        }
    }

}
</script>

<style>
.loader {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/../assets/loading_big.gif');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.4;
    filter: alpha(opacity=40);
}
</style>
